export const forbiddenPhones = new Set([
  "375173753456",
  "375297009627",
  "375445064918",
  "375295777724",
  "375291465808",
  "375447111197",
  "375445622225",
  "375445161140",
  "74953088251",
  "375296700265",
  "375445685700",
  "375445723865",
  "375445723899",
  "375445723913",
]);

export default forbiddenPhones;
